import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './promotion-blocks.scss';

export class PromotionBlocks extends PureComponent {
  render() {
    const { content } = this.props;

    return (
      <div className="promotion-blocks">
        <ul>
          {content.map((block, key) =>
            <li key={key}>
              <div className={cn('promotion-block', `block-${block.type}`)}>
                <div className="promotion-block-value">
                  {(!!block.value) &&
                    <span
                      className="block-value"
                      dangerouslySetInnerHTML={{ __html: block.value }}
                    />
                  }

                  <span
                    className="block-unit"
                    dangerouslySetInnerHTML={{ __html: block.unit }}
                  />
                </div>

                <div
                  className="promotion-block-text"
                  dangerouslySetInnerHTML={{ __html: block.text }}
                />
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

PromotionBlocks.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

export default PromotionBlocks;



// WEBPACK FOOTER //
// ./src/components/Promotion/PromotionBlocks.js